var map = {
	"./en/example.yml": 159,
	"./en/hos.yml": 160,
	"./en/main.yml": 36,
	"./en/markdown.yml": 161,
	"./en/news.yml": 162,
	"./en/sfs.yml": 163,
	"./fr/example.yml": 164,
	"./fr/except.yml": 165,
	"./fr/framablog.yml": 166,
	"./fr/hos.yml": 167,
	"./fr/main.yml": 37,
	"./fr/news.yml": 168,
	"./fr/preamble.yml": 169,
	"./fr/risks_first.yml": 170,
	"./fr/risks_second.yml": 171,
	"./fr/sfs.yml": 172,
	"./fr/understand.yml": 173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 158;